import { render, staticRenderFns } from "./copy-scadenza-playground.vue?vue&type=template&id=63f2c8ae&"
import script from "./copy-scadenza-playground.vue?vue&type=script&lang=js&"
export * from "./copy-scadenza-playground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports